import { render, staticRenderFns } from "./BarrelCarousel.vue?vue&type=template&id=2cdb2efa&"
import script from "./BarrelCarousel.vue?vue&type=script&lang=ts&"
export * from "./BarrelCarousel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports